import React from 'react';
import classNames from 'classnames';
import { Icon } from '../../icon';
export function getDropdownClassName(dropdownClassName, prefixCls, animation) {
    return classNames({
        [`${prefixCls}-dropdown-normal`]: true,
        [`${prefixCls}-bdesign`]: true,
        ['glassmorphism glassmorphism-dropdown']: !!animation?.glassmorphism
    }, dropdownClassName);
}
export function getIcons(picker) {
    return {
        suffixIcon: picker === 'time' ? React.createElement(Icon, { type: 'time--outline' }) : React.createElement(Icon, { type: 'calendar--outline' }),
        clearIcon: React.createElement(Icon, { type: 'close' }),
        prevIcon: React.createElement(Icon, { type: 'chevron--left' }),
        nextIcon: React.createElement(Icon, { type: 'chevron--right' }),
        superPrevIcon: React.createElement(Icon, { type: 'arrow-double--left' }),
        superNextIcon: React.createElement(Icon, { type: 'arrow-double--right' })
    };
}
